export const whitelistedLanguages = [
  'en',
  'de',
  'es',
  'fr',
  'it',
  'ja',
  'ko',
  'lv',
  'nl',
  'pt',
  'sv',
  'zh',
];
